/*
 * resizeImage(image.path, 100)
 */
// Spotify image CDN (replaces the podsights imgix sources). Only serves the
// production bucket, by object key; other buckets get no URL.
const CDN_HOST = 'adanalytics-images.spotifycdn.com';
const CDN_BUCKET = 'podcast-audio-production';

export const resizeImage = (
  path: string,
  width: number,
  height?: number
): string => {
  const match = /^gs:\/\/([-\w]+)\/(.*)$/.exec(path);

  if (!match || match[1] !== CDN_BUCKET) {
    return '';
  }

  let src = `https://${CDN_HOST}/${match[2]}?w=${width * 2}`;

  if (height) {
    src = `${src}&h=${height * 2}`;
  }

  return src;
};
